export const ENTITY_CATEGORIES_LOADING = 'ENTITY_CATEGORIES_LOADING';
export const ENTITY_CATEGORIES_SUCCESS = 'ENTITY_CATEGORIES_SUCCESS';
export const ENTITY_CATEGORIES_FAILURE = 'ENTITY_CATEGORIES_FAILURE';
